import { type ReactNode, type RefObject } from 'react';
import { useScreenSize } from 'src/hooks/useScreenSize';
import { useApplicationServerContext } from '../../state';
import { Desktop } from './Desktop';
import { Mobile } from './Mobile';
import { ServerError } from './ServerError';

export type LoginBoxRef = RefObject<HTMLDivElement>;

export function Layout(props: {
  children?: ReactNode;
  /** Attached to the element that wraps `children`. */
  loginBoxRef?: LoginBoxRef;
}) {
  const { isMobile } = useScreenSize();
  const [serverState] = useApplicationServerContext();
  const isServerError = 'error' in serverState;

  return (
    <>
      {isServerError && <ServerError>{props.children}</ServerError>}
      {!isServerError && isMobile !== undefined && isMobile === true && (
        <Mobile loginBoxRef={props.loginBoxRef}>{props.children}</Mobile>
      )}
      {!isServerError && isMobile !== undefined && isMobile === false && (
        <Desktop loginBoxRef={props.loginBoxRef}>{props.children}</Desktop>
      )}
    </>
  );
}
